function HomePage() {
    return (
        <div className="HomePage">
            Home Page
        </div>
    );
}

export default HomePage;